export default __webpack_public_path__ + "static/media/amazon_PNG25.79a1dd45.png";